module.exports = __webpack_public_path__ + "img/santa_claus.6132d207.gif";